import React from 'react';
import { Bounce, Zoom } from 'react-awesome-reveal'
import AZ from '../../assets/logos/az.png'

const MainContainerAdhesion = () => {
  return (
    <section id="main-container" className="main-container" 
    style={{
        backgroundImage: 'url(images/assets/ban4.jpg)',
        
      }}
    >
      <div className="container">
      <div className="text-center mb-3">
                      <Bounce>
                        <img src={AZ} alt="logo" className="img-fluid mb-3" style={{ maxWidth: 400 }} />
                      </Bounce>
                    
                    </div>
        <div className="row">
          {/* Colonne gauche */}
          <div className="col-lg-12">
          <Zoom>
            <p className='p-2' style={{fontSize:'25px', fontFamily:'Times', fontWeight:'bold', color:'#4c4d4d'}}>
            Nous vous proposons un choix de cartes d’abonnement annuel <br /> vous élevant au statut de membre privilégié Azyekos.
           </p>
           </Zoom> 
 <br />
           <Zoom>
            <p style={{fontSize:'25px', fontFamily:'Times', fontWeight:'bold', color:'#4c4d4d'}}>
            Dès votre adhésion, une assistance permanente sera mise <br /> à votre disposition respectant ainsi vos exigences.
           </p>
           </Zoom> 
           
      
            
          </div>

          {/* Colonne droite */}
        
        </div> {/* Row end */}
      </div> {/* Container end */}
    </section>
  );
};

export default MainContainerAdhesion;
